import { render } from "./EditDishOptionModal.vue?vue&type=template&id=6fe4c74b&lang=pug"
import script from "./EditDishOptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDishOptionModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__